// constants/project.js

export const PROJECT_INITIAL_FORM = {
  name: "",
  developer: "",
  location: "",
  status: "planning",
  url: "",
  image: [],
};


export const PROJECT_STATUS_OPTIONS = [
  {
    value: "planning",
    label: "Đang quy hoạch",
  },
  {
    value: "under-construction",
    label: "Đang thi công",
  },
  {
    value: "ready",
    label: "Sẵn sàng",
  },
  {
    value: "sold-out",
    label: "Đã bán hết",
  },
  {
    value: "inactive",
    label: "Ngưng hoạt động",
  },
];